import {SmartTriggerConfiguration} from "../../../types";
import './smartTriggerCard.css'
import {Avatar, AvatarsGroup, Badge, Blockquote, Button} from "@mantine/core";
import {faPenToSquare} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router-dom";
import {PlayerPlay} from "tabler-icons-react";

export type SmartTriggerCardProps = SmartTriggerConfiguration & {
    color: string
}

const tagColors: Record<string, string> = {
    'reactive': "cyan",
    'scheduled': 'blue',
    'active': 'teal',
    'inactive': 'gray'
}

export function SmartTriggerCard(configuration: SmartTriggerCardProps) {
    const navigate = useNavigate();

    const activeTags = [...configuration.tags]
    if (configuration.activeStatus === 'ACTIVE') {
        activeTags.push('active')
    } else {
        activeTags.push('inactive')
    }

    return (
        <div className={"smart-trigger-card " + configuration.color}>
            <div className={"smart-trigger-card-header"}>
                <div className="smart-trigger-name">
                    <h2 className={"smart-trigger-card-name"}>{configuration.name}</h2>
                </div>
                <div className={"smart-trigger-tags"}>
                    <Button radius={"xl"}
                            onClick={() => navigate("/smart/triggers/" + configuration.id + "?action=run")}
                            color={"teal"} rightIcon={<PlayerPlay/>} size={"xs"} variant="outline">
                        RUN
                    </Button>
                </div>

            </div>
            <hr className={"smart-trigger-divider"}/>
            <div className={"smart-trigger-card-body"}>
                <div>
                    <AvatarsGroup limit={3}>
                        <Avatar size={"xl"}
                                src={require("../../../../../assets/img/notification/channels/push-notification.png")}/>
                        <Avatar size={"xl"}
                                src={require("../../../../../assets/img/notification/channels/sms.png")}/>
                        <Avatar
                            size={"xl"}
                            src={require("../../../../../assets/img/notification/channels/whatsapp.png")}/>

                        {/*<Avatar src={require("./../../processorConfiguration/python.png")}/>*/}
                    </AvatarsGroup>
                </div>
                <div>
                    <Blockquote cite={"– Created By " + configuration.createdBy} icon={null}>
                        <p className={"kpi-card-content-text"}>{configuration.description}</p>
                    </Blockquote>
                </div>
            </div>
            {/*<hr className={"smart-trigger-divider"}/>*/}
            <div className={"smart-trigger-card-footer"}>
                <div>
                    {activeTags.map(tag => (
                        <Badge className={"smart-trigger-card-footer-badge"} variant={"outline"} key={"badge" + tag}
                               color={tagColors[tag]} size="sm">{tag}</Badge>
                    ))}
                </div>
                <div>
                    <FontAwesomeIcon onClick={() => navigate("/smart/triggers/" + configuration.id)}
                                     className={"pointer smart-trigger-edit-button"} icon={faPenToSquare}
                                     color={"rgb(173, 181, 189)"}
                                     size={"1x"}/>
                </div>


            </div>
        </div>
    )
}
